module.exports = __webpack_public_path__ + "static/media/Parcelamento-01.b5668feb.svg";